module.exports = __webpack_public_path__ + "img/tag-precio_.6f78ece0.png";